// extracted by mini-css-extract-plugin
module.exports =  {"root":"uUjtbourOxmMVPurF6HS"};